export default {"src":"/_next/static/media/phone.008ce683.svg","height":18,"width":18};